import api from './api';

/**
 * Photo / evidence URL service for OnDemand events.
 * Each method returns a short-lived viewable URL (signed when stored in S3,
 * passthrough for already-hosted assets, dev-uploads URL otherwise).
 */
class OnDemandPhotoService {
  static getKitPhotoUrl(eventId, assignmentId) {
    return api.get(`/ondemand/events/${eventId}/assignments/${assignmentId}/kit-photo-url`);
  }

  static getDropoffPhotoUrl(eventId) {
    return api.get(`/ondemand/events/${eventId}/dropoff-photo-url`);
  }

  static listEncounters(eventId) {
    return api.get(`/ondemand/events/${eventId}/encounters`);
  }

  static getEncounterCardPhotoUrl(encounterId, side = 'front') {
    return api.get(`/ondemand/encounters/${encounterId}/card-photo-url?side=${side}`);
  }
}

export default OnDemandPhotoService;
